import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  Typography,
  Tooltip
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded"; // ใช้ไอคอนที่ดูทันสมัย
import LoginRoundedIcon from "@mui/icons-material/LoginRounded"; // นำเข้าไอคอนล่วงหน้า

import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

import logo1 from "../../../assets/logo/RIHES-Sub-Logo-Color.png";

const sections = [
  { id: "home", label: "หน้าแรก" },
  // { id: "documents", label: "เอกสารโครงการวิจัย" },
  // { id: "publication", label: "สื่อเผยแพร่" },
  { id: "system", label: "ระบบเฝ้าระวังออนไลน์" },
  { id: "contact", label: "Contact Us" }
];
const Navbar = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // const scrollTo = id => {
  //   const el = document.getElementById(id);
  //   if (el) {
  //     el.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          const yOffset = -80; // ปรับ offset ให้พอดีกับ AppBar
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }, 200);
      }
    }

    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token); // ถ้ามี token = login แล้ว
  }, []);

  return (
    <React.Fragment>
      {/* 🔷 Top bar */}
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "#347433", height: 30, zIndex: 1201 }}
      >
        <Toolbar
          disableGutters
          sx={{
            height: "100%", // ✅ ให้ Toolbar ยืดเต็ม AppBar
            px: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center" // ✅ จัดกึ่งกลางแนวตั้ง
          }}
        >
          {/* ฝั่งซ้าย: ข้อความ */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center", // ✅ ข้อความอยู่กึ่งกลางแนวตั้ง
              height: "100%"
            }}
          >
            <Typography
              sx={{
                color: "#ccc",
                fontSize: "0.8rem",
                lineHeight: 1,
                cursor: "pointer"
              }}
              style={{ marginTop: "-30px" }}
              onClick={() =>
                window.open("https://www.rihes.cmu.ac.th/", "_self")}
            >
              www.rihes.cmu.ac.th | สถาบันวิจัยวิทยาศาสตร์สุขภาพ
            </Typography>
          </Box>

          {/* ฝั่งขวา: ไอคอน */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              height: "100%"
            }}
            style={{ marginTop: "-30px" }}
          >
            <IconButton
              component="a"
              href="https://www.facebook.com/rihescmufanpage"
              target="_blank"
            >
              <FacebookIcon sx={{ fontSize: 20, color: "#ccc" }} />
            </IconButton>

            <IconButton component="a" href="">
              <EmailIcon sx={{ fontSize: 20, color: "#ccc" }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* 🔶 Main navbar */}
      <AppBar
        position="fixed"
        sx={{ top: 30, backgroundColor: "#fff", height: 80 }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* 🔵 Logo Section  */}
          <Box
            onClick={() => (window.location.href = `/#home`)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer"
            }}
          >
            <img src={logo1} alt="Logo" style={{ height: 75 }} />
            {/* <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            MyBrand
          </Typography> */}
          </Box>

          {/* 🔹 Desktop menu */}
          {!isMobile &&
            <Box
              sx={{
                display: "flex",
                gap: 2,
                backgroundColor: "#fff",
                padding: "10px 20px",
                borderRadius: "12px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
              }}
            >
              {sections.map(sec =>
                <Button
                  key={sec.id}
                  sx={{
                    color: "#333",
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    backgroundColor: "transparent",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      color: "#fff",
                      backgroundColor: "#1976d2",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
                    }
                  }}
                  onClick={() => {
                    // scrollTo(sec.id);
                    window.location.href = `/#${sec.id}`;
                  }}
                >
                  {sec.label}
                </Button>
              )}

              {/* 🔑 Login Button */}
              {isLoggedIn
                ? <Tooltip title="Logout">
                    <IconButton
                      onClick={() => {
                        localStorage.removeItem("token");
                        setIsLoggedIn(false);
                        window.location.href = "/login";
                      }}
                      sx={{
                        background: "rgba(255, 255, 255, 0.7)",
                        backdropFilter: "blur(6px)",
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",
                        padding: "8px",
                        color: "#d32f2f",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          background: "rgba(211, 47, 47, 0.1)",
                          boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.15)",
                          color: "#b71c1c"
                        }
                      }}
                    >
                      <PowerSettingsNewIcon />
                    </IconButton>
                  </Tooltip>
                : <Tooltip title="Login">
                    <IconButton
                      onClick={() => window.open("/login", "_blank")}
                      sx={{
                        background: "rgba(255, 255, 255, 0.7)",
                        backdropFilter: "blur(6px)",
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",
                        padding: "8px",
                        color: "#1976d2",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          background: "rgba(25, 118, 210, 0.1)",
                          boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.15)",
                          color: "#0d47a1"
                        }
                      }}
                    >
                      <LoginRoundedIcon />
                    </IconButton>
                  </Tooltip>}
            </Box>}

          {/* 🍔 Mobile menu icon */}
          {isMobile &&
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpen(true)}
              sx={{
                color: "#000",
                backgroundColor: "transparent", // พื้นหลังปกติ
                "&:hover": {
                  color: "#fff", // สีข้อความตอน hover
                  backgroundColor: "#1976d2" // พื้นหลังตอน hover (สีน้ำเงินตัวอย่าง)
                }
              }}
            >
              <MenuRoundedIcon sx={{ fontSize: 32 }} />
            </IconButton>}
        </Toolbar>
      </AppBar>

      {/* 📱 Drawer for mobile */}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            background: "rgba(255, 255, 255, 0.3)", // ทำให้ดูโปร่งใส
            backdropFilter: "blur(10px)", // Glassmorphism effect
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)", // เพิ่มมิติ
            borderRadius: "12px 0px 0px 12px", // ทำให้มุมโค้งมน
            padding: "20px"
          }
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ width: 250, pt: "30px" }} role="presentation">
            <List>
              {sections.map(sec =>
                <ListItem key={sec} disablePadding>
                  <ListItemButton
                    sx={{
                      color: "#000",
                      borderRadius: "8px",
                      backgroundColor: "transparent",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        color: "#fff",
                        backgroundColor: "#1976d2",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
                      }
                    }}
                    onClick={() => {
                      // scrollTo(sec.id);
                      window.location.href = `/#${sec.id}`;

                      setOpen(false); // ปิด Drawer หลังคลิก
                    }}
                  >
                    <ListItemText primary={sec.label} />
                  </ListItemButton>
                </ListItem>
              )}
              {/* 🔐 Login button with icon - at bottom of list */}
              <ListItem disablePadding sx={{ mt: 1 }}>
                <ListItemButton
                  sx={{
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(6px)",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: "10px",
                    color: "#1976d2",
                    gap: 1,
                    "&:hover": {
                      backgroundColor: "rgba(25, 118, 210, 0.1)",
                      color: "#0d47a1"
                    }
                  }}
                  onClick={() => {
                    if (isLoggedIn) {
                      localStorage.removeItem("token");
                      setIsLoggedIn(false);
                      window.location.href = "/";
                    } else {
                      window.open("/login", "_blank");
                    }
                    setOpen(false);
                  }}
                >
                  {isLoggedIn ? <PowerSettingsNewIcon /> : <LoginRoundedIcon />}

                  <ListItemText primary={isLoggedIn ? "Logout" : "Login"} />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </motion.div>
      </Drawer>
    </React.Fragment>
  );
};

export default Navbar;
